import { PropKeys } from '../../constants';
import { API } from '../../lib/api';

export const getClients = async ({ token, saveClients }) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  let {
    data: clients,
    status,
    error,
  } = await API.GET('user_profile/clients', config);

  if (status !== 200 || error) clients = [];
  saveClients(format(clients));
};

const format = data => {
  if (data == null) return [];
  return data.map(entry => formatClient(entry));
};

export const formatClient = data => {
  if (data == null) return {};
  const { brID, brImage, brName, bguaIsFavorite } = data;

  return {
    [PropKeys.brandId]: brID,
    [PropKeys.brandImage]: brImage,
    [PropKeys.brandName]: brName,
    [PropKeys.favoritedBrand]: bguaIsFavorite,
  };
};
